export default "__VITE_ASSET__YBTWMHP4__"